import { Folder, GitCompareArrows, ReceiptText } from "lucide-react"

interface ToolCard {
    title: string
    description: string
    path: string
    icon: React.ComponentType<{ className?: string }>
}

export const TOOLS: ToolCard[] = [
    {
        title: "Applications",
        description: "Upload and manage grant applications. View application status, details, and review scores.",
        path: "/applications",
        icon: ReceiptText,
    },
    {
        title: "Report Generation",
        description: "This tool creates consistent content for funder and partner reports by using tested AI instructions to generate roll-up data and project summaries. Staff can highlight specific themes and species for focused narratives and metrics.",
        path: "/report-generator",
        icon: Folder,
    },
    {
        title: "Document Comparison",
        description: "Compare Document versions to identify changes between submissions.",
        path: "/compare",
        icon: GitCompareArrows,
    }
]